import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../../../services/invoice.service';
import { ToastrService } from 'ngx-toastr';
import { CreateloadService } from '../../../services/createload.service';
import { MatDialog } from '@angular/material/dialog';
import { ErpmissinginfopopupComponent } from '../erpmissinginfopopup/erpmissinginfopopup.component';
import { CustomersService } from '../../../services/customers.service';
import moment from 'moment';

@Component({
  selector: 'app-erp-sales-orders',
  templateUrl: './erp-sales-orders.component.html',
  styleUrls: ['./erp-sales-orders.component.scss'],
  providers: [ToastrService, CustomersService]
})
export class ErpSalesOrdersComponent implements OnInit {
  constructor(private invoiceService: InvoiceService, private _toaster: ToastrService, private loadService: CreateloadService, public dialog: MatDialog, private _customersservice: CustomersService,) { }
  activeTab: string = 'orders';
  salesOrders = [];
  salesOrdersConst = [];
  allowedPageSizes = [5, 10, 20];
  displayMode = 'full';
  showPageSizeSelector = true;
  showInfo = true;
  showNavButtons = true;
  selectedRows = [];
  loads = [];
  filteredCustomers: any = [];
  customerdata = []
  customerNameIdMap = {}
  salesOrderSearch = {
    customer: "",
    customerId: "",
    orderNo: "",
    fromDate: "",
    toDate: "",
  };
  async ngOnInit() {
    await this.getLoadData();
    this.getData();
    this.getCustomerdata();
    console.log(this.salesOrders);
  }
  /*   getData() {
      this.invoiceService.getBCSalesOrderList().subscribe((data) => {
        // this.salesOrders = data.result;
        for (let i = 0; i < data.result.length; i++) {
          const salesOrder = data.result[i];
          let salesOrderObj = {
            customer: salesOrder?.CustomerName,
            orderNo: salesOrder?.OrderNo,
            postingDate: salesOrder?.PostingDate,
            salesLines: []
          }
          for (let j = 0; j < salesOrder.SalesLines.length; j++) {
            const salesLine = salesOrder.SalesLines[j];
            let salesLineObj = {
              amount: salesLine?.LineAmount,
              unitPrice: salesLine?.UnitPrice,
              quantity: salesLine?.Quantity,
              loadNumber: salesLine?.Load,
            }
            salesOrderObj.salesLines.push(salesLineObj);
          }
          this.salesOrders.push(salesOrderObj);
          }
      });
    } */
  getData() {
    this.invoiceService.getBCSalesOrderList().subscribe((data) => {
      this.salesOrders = [];
      let orders = data && data.result.length > 0 ? data.result.reverse() : [];
      for (let order of orders) {
        let salesOrder = {
          customer: order.CustomerName,
          customerId: order.CustomerId,
          orderNo: order.OrderNo,
          postingDate: order.PostingDate,
          salesLines: []
        };

        for (let line of order.SalesLines) {
          salesOrder.salesLines.push({
            itemNo: line.ItemNo,
            description: line.Description,
            amount: line.LineAmount,
            unitPrice: line.UnitPrice,
            quantity: line.Quantity,
            loadNumber: line.Load ? Number(line.Load) : ""
          });
        }

        this.salesOrders.push(salesOrder);
        this.salesOrdersConst.push(salesOrder);
      }

    });
  }

  async getLoadData() {
    this.loadService.getLoadData().subscribe((data) => {
      let loadData = data.result.filter((load) => load.loadStatus == "5");
      this.loads = loadData;
    });
  }
  getCustomerdata() {
    this.customerdata = [];
    this._customersservice.getCustomersData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].name != undefined) {
          this.customerdata.push(data.result[i]);
          console.log(this.customerdata);
          this.customerNameIdMap[data.result[i].name] = data.result[i]._id;
          console.log(this.customerNameIdMap);
        }
      }
    });
    this.filteredCustomers = this.customerdata;
  }
  onCustomerChange(value) {
    if (value != "") {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      this.filteredCustomers = this.customerdata.filter((option) =>
        option.name.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
    } else {
      this.filteredCustomers = this.customerdata;
    }
  }
  // regular,
  // cancelled

  onCustomerSelected(customerName) {
    if (customerName != "") {
      this.salesOrderSearch.customer = customerName;
      this.salesOrderSearch.customerId = this.customerNameIdMap[customerName];
      console.log(this.salesOrderSearch.customer);
    }
  }
  isAnyLoadMissing(salesOrder: any): boolean {
    return salesOrder.salesLines.some((line: any) => !line.loadNumber);
  }

  // Method to check if all sales lines have load information
  isAllLoadPresent(salesOrder: any): boolean {
    return salesOrder.salesLines.every((line: any) => line.loadNumber);
  }
  getLoadNumbers(salesOrder) {
    return salesOrder.salesLines.map((line) => line.loadNumber)
  }
  syncSalesOrder(salesOrder) {
    let dialogConfig = Object.assign(
      { width: "700px" },
      { data: { loads: this.loads, salesOrder: salesOrder } },
      { disableClose: true }
    );
    let editDialogRef = this.dialog.open(ErpmissinginfopopupComponent, dialogConfig);
    editDialogRef.afterClosed().subscribe((data) => {
      console.log("sales order data data ", data);
      if (data) {
        let isLoadPresent = this.isAllLoadPresent(data);
        if (isLoadPresent) {
          let loadData = {};
          let loadNumbers = this.getLoadNumbers(data);
          loadData["companyId"] = localStorage.getItem("selectedCompany");
          loadData["customerId"] = salesOrder.customerId;
          loadData["customerName"] = salesOrder.customer;
          // loadData["customerAddress"] = customerAddress;
          loadData["loadNumbers"] = loadNumbers;
          // loadData["loadId"] = selectedload._id;
          loadData["createdBy"] = localStorage.getItem("userId");
          console.log(loadData);
          this.invoiceService.createInvoice(loadData, salesOrder?.orderNo).subscribe(
            (data) => {
              console.log(data);
              if (data.Status == "error") {
                this._toaster.error(data.error, "Failed", { timeOut: 1000 });
              } else {
                this.getData();
                this._toaster.success("Invoice successfully synced", "Success", { timeOut: 1000 });
              }
            },
            (error) => {
              this._toaster.error("error", "Try Again", { timeOut: 1000 });
            }
          );
        }
        else {
          let salesLinesData = salesOrder.salesLines.map((salesLine) => {
            return {
              item: salesLine.itemNo,
              description: salesLine.description,
              quantity: salesLine.quantity,
              rate: salesLine.unitPrice,
              lineItemAmount: salesLine.amount,
            }
          })
          const salesOrderData = {
            orderNo: salesOrder?.orderNo,
            customerId: salesOrder.customerId,
            customer: salesOrder.customer,
            postingDate: salesOrder.postingDate,
            salesLines: salesLinesData
          };
          this.invoiceService.updateBCSalesOrder(salesOrderData).subscribe(() => {
            console.log(data);
            if (data.Status == "error") {
              this._toaster.error(data.error, "Failed", { timeOut: 1000 });
            } else {
              this.activeTab = "invoices"
              this.getData();
              this._toaster.success("Invoice successfully Posted", "Success", { timeOut: 1000 });
            }
          }, (error) => {
            this._toaster.error("error", "Try Again", { timeOut: 1000 });
          })
        }
      }
    });
  }
  onSearch() {
    console.log(this.salesOrderSearch);
    console.log(this.salesOrdersConst);
    this.salesOrders = this.salesOrdersConst;
    for (const [key, value] of Object.entries(this.salesOrderSearch)) {
      if (key != "fromDate" && key != "toDate" && value) {
        this.salesOrders = this.salesOrdersConst.filter((option) => {
          console.log("key", key, "value", value);
          if (JSON.stringify(option[key] ? option[key] : "") == JSON.stringify(value)) {
            return option;
          }
        });
      } else if (key == "fromDate" && value) {
        this.salesOrders = this.salesOrdersConst.filter((option) => {
          if (moment(option["postingDate"]) >= moment(value)) {
            return option;
          }
        });
      } else if (key == "toDate" && value) {
        const currentMonth = moment().format("YYYY-MM");
        this.salesOrders = this.salesOrdersConst.filter((option) => {
          if (moment(option["postingDate"]) <= moment(value)) {
            return option;
          }
        });
      }
    }
  }
  onReset() {
    this.salesOrderSearch = {
      customerId: "",
      customer: "",
      orderNo: "",
      fromDate: "",
      toDate: "",
    };
    this.salesOrders = this.salesOrdersConst;
    this.filteredCustomers = this.customerdata;
  }

}
